import { Product } from '@framework/types';
import { CartItem } from '@contexts/cart/cart.context';

interface Item {
  id: string | number;
  name: string;
  slug?: string;
  image?: {
    thumbnail: string;
    [key: string]: unknown;
  };
  photo?: {
    x600: string;
    [key: string]: unknown;
  };
  price: number;
  sale_price?: number;
  [key: string]: unknown;
}

export const generateCartItem = (product: Product, attributes: any): CartItem => {
  return {
    id: Number(product.id),
    name: product.name,
    productCode: product.productCode,
    quantity: 1,
    cost: product.strPrice,
    img: product.photo?.x600 || '/assets/placeholder/products/product-thumbnail.svg',
  };
};
